import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";

import { Add, Edit } from '@mui/icons-material';
import essWorkReportServices from '../essWorkReportServices';
import { useAlert } from '../../../../context/AlertContext';

import Webcam from "react-webcam";
import { AutoAwesome, CameraAlt } from '@mui/icons-material';
import Tesseract from 'tesseract.js';
import api from '../../../../api/api'



function CameraImage({selectCameraImage}) {

    const [facingMode,setFacingMode] = useState("user")
    const swicthCamera = () =>{
        if(facingMode == "user"){
            setFacingMode("environment")
        }
        if(facingMode == "environment"){
            setFacingMode("user")
        }
    }

    const videoConstraints = {
        facingMode: facingMode,
    };

    
    const [dialogStatus,setDialogStatus] = useState(false);

    return (
    <>
        <button type="button" className="btn btn-dark btn-lg mt-2" onClick={()=>setDialogStatus(true)}><CameraAlt/> Open Camera</button>
        <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullScreen={true}
                aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent style={{padding:0}}>
            <div className="row">
                <div className="col-md-12 text-center">
                    {dialogStatus == true &&
                        <Webcam
                            audio={false}
                            
                            screenshotFormat="image/jpeg"
                           
                            videoConstraints={videoConstraints}
                        >
                            {({ getScreenshot }) => (
                                <><br/>
                                <button
                                    className="btn btn-primary m-2"
                                    onClick={() => {
                                        let imageSrc = getScreenshot();
                                        selectCameraImage(imageSrc);
                                        setDialogStatus(false);
                                    }}
                                
                                >
                                    Capture photo
                                </button>
                                <button type="button" onClick={swicthCamera} className="btn btn-dark m-2">Switch Camera</button>
                                <button type="button" onClick={()=>setDialogStatus(false)} className="btn btn-outline-primary m-2">Cancel</button>
                                </>
                            )}
                        </Webcam>
                    }
                </div>
            </div>
            </DialogContent>
        </Dialog>
    </>
  )
}



function EssWorkReportForm({data,callBack }) {

    const [report,setReport] = useState ("");
    const {AppAlert} = useAlert()
    const [dialogStatus,setDialogStatus] = useState(false);
    const [saving, setSavingStatus] = useState(false);

    const [selectedFile,setSelectedFile] = useState(null);

    const [uploadInProgress, setUploadProgress] = useState(null);
    
    

    const onSubmit1 = ( onSubmitProps) => {
        let payload ={
            report:report,
        }
        if(data){
            payload.id=data.id
        }
        essWorkReportServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    const handleClose = () =>{
        setSelectedFile(null)
        setDialogStatus(false)
    }

    const uploadToServer = (formData) =>{ 
        api.post("/ess/work-report",formData,{
            onUploadProgress: (progressEvent) => { 
                const { loaded, total } = progressEvent;
                let percent = Math.floor((loaded * 100) / total);
                //console.log(percent);
                setUploadProgress(percent)
            },
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }).then( (res)=>{
            AppAlert(res.data.msg)
            callBack();
        }).catch( (error) => {
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setUploadProgress(null)
            handleClose();
        })
      }

    const onSubmit = () => {
        let formData = new FormData();
        
        formData.append('report',report);
        if(selectedFile !== null){
            formData.append('tmpFile', selectedFile);
        }

        if(data){
            formData.append('id', data.id);
        }
        
        //console.log("hefre");
        //console.log(formData)
        uploadToServer(formData);
    }

    const addNew =() =>{
        setReport("");
        setDialogStatus(true);
    }

    const updateData = () =>{
        setReport(data.report);
        setDialogStatus(true);
    }




    const isImage = (file) =>{
        if(file.type.match('image.*')){
            return true;
        }
        return false;
    }
    
    const selectFile = (e) =>{
        if(!isImage(e.target.files[0])){
            AppAlert("Invalid File Type","error");
            return false;
        }
        setSelectedFile(e.target.files[0])
    }


    /*****   Camera Work In Progress */
    const  DataURIToBlob = (dataURI) => {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)
        return new Blob([ia], { type: mimeString })
    }
    const selectCameraImage = (image) => {
        setSelectedFile(DataURIToBlob(image))
    }

    const readTextFromImage = async () =>{
        const result = await Tesseract.recognize(selectedFile);
        setReport(result.data.text);
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogContent>

                    
                    <div className='row'>
                        
                        {selectedFile == null &&
                            <div className='col-md-6'>
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <CameraImage selectCameraImage={selectCameraImage} />
                                    </div>
                                    <div>
                                        <div className="form-group mt-2">
                                            <input type="file"
                                                className='d-none'
                                                onChange={ (e)=>{ selectFile(e) } } 
                                                accept="image/png, image/gif, image/jpeg"
                                                id="uploadDocumentImage" 
                                            />
                                            <label for="uploadDocumentImage" className='btn btn-primary ms-2 btn-lg'>Upload Image</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    
                    
                        {selectedFile !== null && 
                            <div className='col-md-6'>
                                <div className='text-center'>
                                    <img className='img-fluid' style={{maxHeight:400}}  alt="preview image" src={URL.createObjectURL(selectedFile)} />
                                </div>
                            </div>
                        }
                        
                        <div className='col-md-6 mt-2'>
                            <div className="mb-3 ">
                                <label >Enter Your Today's Work Summery * </label>
                                {selectedFile !== null && 
                                    <button className='btn btn-outline-success float-end mb-2' onClick={()=>readTextFromImage()} ><AutoAwesome/> Read Text From Image</button>
                                }
                                <textarea  className="form-control"  placeholder=""  value={report} onChange={(e)=>setReport(e.target.value)} style={{height:100}} />
                            </div>
                        </div>
                    </div>
                    
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)}>Cancel</button>
                    <button className='btn btn-primary' type="button" onClick={onSubmit} type='button'>Submit</button>
                    
                </DialogActions>
            </Dialog>

        </>
    )
}

export default EssWorkReportForm